import * as Yup from 'yup';
import { messages } from 'app/config/constants';
import { SUBJECT_TYPE_ENUM, WRITTEN_STATEMENT_TYPE_ENUM } from 'app/shared/enumeration/enums';
import { defaultAddressValidation } from 'app/shared/address-input/model/address.schema';

export const finalReportOfSupervisingEngineerValidationSchema = Yup.object().shape({
  finalReportType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  mark: Yup.string().required(messages.MANDATORY_FIELD),
  reportDate: Yup.date().required(messages.MANDATORY_FIELD),
  supervisingEngineer: Yup.object({
    authorizationNumber: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  }),
});

export const writtenStatementValidationSchema = Yup.object().shape({
  writtenStatementType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  mark: Yup.string().required(messages.MANDATORY_FIELD),
  statementDate: Yup.date().required(messages.MANDATORY_FIELD),
  subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  person: Yup.object()
    .nullable()
    .notRequired()
    .when(['subjectType'], (subjectType, schema) => {
      if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
        return Yup.object({
          oib: Yup.string()
            .required(messages.MANDATORY_FIELD)
            .matches(/^\d+$/, messages.ONLY_DIGITS)
            .min(11, messages.OIB_MIN_MAX_LENGTH)
            .max(11, messages.OIB_MIN_MAX_LENGTH),
          firstName: Yup.string().required(messages.MANDATORY_FIELD),
          lastName: Yup.string().required(messages.MANDATORY_FIELD),
        });
      } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
        return Yup.object({
          oib: Yup.string().notRequired(),
          firstName: Yup.string().notRequired(),
          lastName: Yup.string().notRequired(),
        }).notRequired();
      }
    }),
  legalEntity: Yup.object().when('subjectType', (subjectType, schema) => {
    if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
      return Yup.object({
        oib: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .min(11, messages.OIB_MIN_MAX_LENGTH)
          .max(11, messages.OIB_MIN_MAX_LENGTH),
        mb: Yup.string().notRequired(),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      });
    } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        companyName: Yup.string().notRequired(),
      }).notRequired();
    } else if (
      subjectType &&
      subjectType[0] &&
      subjectType[0][0] &&
      (subjectType[0][0].id === SUBJECT_TYPE_ENUM.OBRT ||
        subjectType[0][0].id === SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST ||
        subjectType[0][0].id === SUBJECT_TYPE_ENUM.OPG)
    ) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        mb: Yup.string().required(messages.MANDATORY_FIELD).matches(/^\d+$/, messages.ONLY_DIGITS).max(11, messages.MB_MIN_MAX_LENGTH),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      }).notRequired();
    }
  }),
  siteConstructorAddress: defaultAddressValidation,
  chiefConstructionEngineer: Yup.object().when('writtenStatementType', (val, schema) => {
    return val[0][0]?.id === WRITTEN_STATEMENT_TYPE_ENUM.PISANA_IZJAVA_GLAVNOG_IZVODACA
      ? Yup.object({
          authorizationNumber: Yup.array().notRequired(),
          oib: Yup.object().when('authorizationNumber', (val, schema) => {
            if (val[0] && val[0][0] && (val[0][0].oib === '' || val[0][0].oib === null)) {
              return Yup.string().required(messages.MANDATORY_FIELD);
            }
            return Yup.string().notRequired();
          }),
        })
      : Yup.object().notRequired();
  }),
});
